var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.header.render,{tag:"component",attrs:{"item":_vm.getValue(_vm.item, _vm.header.key, _vm.header),"items":_vm.getValues(_vm.item, _vm.header.keys, _vm.header)}})
}
var staticRenderFns = []

export { render, staticRenderFns }